module.exports = __webpack_public_path__ + "assets/img/second-screenshot-mob.c6d3ccd5.png";